export enum AlertTypes {
  audit = 0,
  security = 1,
  system = 2,
  corrupted = 3,
  deploymentHealth = 4
}
